export class InvalidFieldsError extends Error {
  constructor(
    message: string,
    public readonly invalidFields: Record<string, string | string[]>
  ) {
    super(message);
  }
}
